function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import StyledWeekday from "./weekday.style";
import StyledAbbr from "./abbr.style";
export const Weekday = ({
  className,
  title,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledWeekday, _extends({
  className: className,
  role: "columnheader"
}, props), /*#__PURE__*/React.createElement(StyledAbbr, {
  title: title
}, children));
export default Weekday;